import type {
  UserSettingApi,
  UserSettingsGetResultApi,
  UserSettingUpdateResultApi,
} from 'api-typings/users/users';
import type { UserSetting } from './user-settings.model';

export function transformUserSettingGetResult(
  result: UserSettingsGetResultApi,
): readonly UserSetting[] {
  return result.user_settings.map(setting => ({
    id: getUserSettingId(setting),
    userId: setting.user_id,
    context: setting.context,
    target: setting.target,
    targetId: setting.target_id,
    value: setting.value,
  }));
}

export function transformUserSettingUpdateResult(
  result: UserSettingUpdateResultApi,
): UserSetting {
  const value = result.user_setting;
  return {
    id: getUserSettingId(value),
    userId: value.user_id,
    context: value.context,
    target: value.target,
    targetId: value.target_id,
    value: value.value,
  };
}

export function getUserSettingId(setting: UserSettingApi): string {
  let id = `${setting.context}-${setting.target}`;

  if (setting.target_id !== undefined) {
    id += `-${setting.target_id}`;
  }

  return id;
}
